import React from "react";
import PropTypes from "prop-types";
import Truncate from "react-truncate";

import { IconButton } from "material-ui";
import { NavigationMoreHoriz } from "material-ui/svg-icons";

import { Tipografia, Flex } from "../..";

const styles = {
  smallIcon: {
    width: 18,
    height: 18,
  },
  small: {
    width: 24,
    height: 24,
    padding: 0,
    margin: "0px 0px 0px 8px",
  },
};

class ReadMore extends React.Component {
  constructor(...args) {
    super(...args);

    this.state = {
      expanded: false,
      truncated: false,
    };

    this.handleTruncate = this.handleTruncate.bind(this);
    this.toggleLines = this.toggleLines.bind(this);
  }

  handleTruncate(truncated) {
    if (this.state.truncated !== truncated) {
      this.setState({
        truncated,
      });
    }
  }

  toggleLines(event) {
    event.preventDefault();

    this.setState({
      expanded: !this.state.expanded,
    });
  }

  render() {
    const { children, lines, TipografiaProps, ExtraComponent, id } = this.props;
    const { expanded, truncated } = this.state;

    return (
      <Flex flexDirection="column" id={id}>
        <Tipografia className={TipografiaProps?.className} tipo={TipografiaProps?.tipo} cor={TipografiaProps?.cor}>
          <Truncate lines={!expanded && lines} ellipsis={<span />} onTruncate={this.handleTruncate}>
            {children}
          </Truncate>
        </Tipografia>
        {(truncated || expanded) && (
          <Flex alignItems="center" justifyContent="flex-end">
            {ExtraComponent && expanded && <ExtraComponent />}
            <IconButton
              onClick={this.toggleLines}
              id="btnVerMais"
              title={expanded ? "Ver menos" : "Ver mais"}
              iconStyle={styles.smallIcon}
              style={styles.small}
            >
              <NavigationMoreHoriz color="#666666" />
            </IconButton>
          </Flex>
        )}
      </Flex>
    );
  }
}

ReadMore.defaultProps = {
  lines: 3,
  TipografiaProps: {},
};

ReadMore.propTypes = {
  children: PropTypes.node.isRequired,
  lines: PropTypes.number,
  TipografiaProps: PropTypes.object,
  id: PropTypes.string,
  ExtraComponent: PropTypes.element,
};

export default ReadMore;
